import { useQuery } from '@tanstack/react-query';
import { accountsApi } from '../services/accountsApi';
import type { AccountTenantSummary } from '../types/accounts';

/**
 * D3 W19 — fetch the list of tenants belonging to an account.
 *
 * Backs the multi-tenant invite form: when an Account Owner / master_admin /
 * super_admin / tenant_admin opens the invite modal with the "multi-tenant"
 * toggle on, this hook supplies the available targets.
 *
 * Caching: 60s staleTime to mirror the BFF cache-tag for `/accounts/:id/tenants`.
 * The hook is a no-op (`enabled: false`) until `accountId` is known.
 */
export function useAccountTenants(accountId: string | undefined) {
  return useQuery<AccountTenantSummary[]>({
    queryKey: ['account', accountId, 'tenants'],
    queryFn: () => accountsApi.getAccountTenants(accountId as string),
    enabled: Boolean(accountId),
    staleTime: 60_000,
  });
}
